import { IPageableAlt, IPageableAltSort } from './pageable.model';

export interface IPagination<T> {
  content?: T[]; // required for new pagination to also work with old logic
  items?: T[];
  totalElements: number;
  config: {
    sortColumns: string[];
  };
  rowCss?: (a: object) => boolean;
}

export function emptyPage<T>(): IPagination<T> {
  return { items: [], totalElements: 0, config: { sortColumns: [] } };
}

export interface IPaginationAlt<T> {
  // new way of doing pagination
  content: T[];
  empty: boolean;
  first: boolean;
  items?: T[]; // can be removed once we get rid of old pagination types
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: IPageableAlt;
  rowCss?: (a: object) => boolean;
  size: number;
  sort: IPageableAltSort;
  totalElements: number;
  totalPages: number;
}
